import React, { useEffect, useMemo, useState } from 'react'
import styled from '@emotion/styled'
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined'
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
  Stack
  // TextField
} from '@mui/material'
import Avatar from '@mui/material/Avatar'
import Pagination from '@mui/material/Pagination'
import { useQuery } from '@tanstack/react-query'
import DataApi from 'api/faber/DataApi'
import EsimAPI from 'api/faber/EsimAPI'
import PaymentAPI from 'api/faber/PaymentAPI'
// import DateRangePicker from 'common/AbstractDateRangePicker/AbstractDateRangePicker'
// import CustomSearchbarFilter from 'common/AbstractDropdown/CustomSearchbarFilter'
import ColorBox from 'common/Box/ColorWhiteBox'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
// import { isWithinInterval } from 'date-fns'
import format from 'date-fns/format'
// import { changeMonth } from 'helpers/date'
import OrbitSession from 'hooks/useCookies'
import useModal from 'hooks/useModal'
import useOrbitFlag from 'hooks/useOrbitFlag'
import { TransformedFaberUserData } from 'types/api/faber/globalCustomers.type'
import {
  GetCustomerPaymentTransaction,
  InvoiceTransaction
} from 'types/api/faber/payment.type'

import {
  RefundFormV2Dialog,
  RefundReceiptDialog,
  ResendReceiptDialog
} from '../sharedDialogs'

import { ALLOWED_ROLES } from './constant'
// import FilterTransactionBtn from './FilterTransactionBtn'
// TO DO: Remove when not necessary
// import PaymentDetailV2 from './PaymentDetailV2'
import NoPermissionSnackbar from './NoPermissionSnackbar'
import { RefundFormV3Dialog } from './RefundFormDialogV3'
import RefundHistoryDialog from './RefundHistoryDialog'

// TO DO: to show payment transaction type- for subscription or one time product

const waivedTransactionRegex = (txn: string) => {
  return /(waived|Waived)/.test(txn)
}

const StyledHeaderText = styled(NormalText)({
  fontSize: '0.8em',
  color: '#818D9C',
  fontWeight: 700
})

const StyledBodyText = styled(NormalText)({
  fontSize: '0.65em'
})

interface TransactionActionMenuProps {
  tx: GetCustomerPaymentTransaction
  customerRow: TransformedFaberUserData
  setTransactionData: React.Dispatch<
    React.SetStateAction<GetCustomerPaymentTransaction | undefined>
  >
  handleRefundDialog: () => void
  handleReceiptDialogOpen: () => void
  handlePartialRefundDialog: () => void
  handleRefundReceiptDialogOpen: () => void
}

const TransactionActionMenu = ({
  tx,
  setTransactionData,
  handleReceiptDialogOpen,
  handlePartialRefundDialog,
  handleRefundReceiptDialogOpen
}: TransactionActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        sx={{
          borderRadius: '20%',
          px: 2,
          backgroundColor: circlesOrbitColorPalette.toolkit.main,
          boxShadow: 3,
          '&:hover': {
            backgroundColor: '#dcddf1'
          },
          '&:disabled': {
            backgroundColor: circlesOrbitColorPalette.neutrals[200]
          }
        }}
        onClick={(e) => {
          handleMenuClick(e)
          setTransactionData(tx)
        }}
      >
        <MoreHorizIcon />
      </IconButton>

      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuList>
          <MenuItem
            onClick={() => {
              handlePartialRefundDialog()
              handleMenuClose()
            }}
            disabled={
              tx?.paymentStatus === 'REFUNDED' ||
              tx?.paymentStatus === 'refunded' ||
              (tx && waivedTransactionRegex(tx.trn)) ||
              tx?.amount === 0
            }
          >
            <ListItemIcon>
              <PriceChangeOutlinedIcon />
            </ListItemIcon>
            <TextColorFontBody>Refund</TextColorFontBody>
          </MenuItem>

          <MenuItem
            onClick={() => {
              if (tx?.paymentStatus === 'REFUNDED') {
                handleRefundReceiptDialogOpen()
              } else {
                handleReceiptDialogOpen()
              }
            }}
          >
            <ListItemIcon>
              <ForwardToInboxIcon />
            </ListItemIcon>
            <TextColorFontBody>
              Send {tx?.paymentStatus === 'REFUNDED' && 'Refund '}
              Receipt
            </TextColorFontBody>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  )
}

function PaymentLogsV2({
  customerId,
  customerRow,
  handleRefundRequestTabChange
}: PaymentLogsProps) {
  const faberAdminRole = OrbitSession.get('role')
  const faberRefundFlag = useOrbitFlag('refund-v2')

  const [receiptDialogOpen, setReceiptDialogOpen] = useState(false)
  const [refundReceiptDialogOpen, setRefundReceiptDialogOpen] = useState(false)

  const handleReceiptDialogOpen = () => {
    setReceiptDialogOpen(true)
  }

  const handleReceiptDialogClose = () => {
    setReceiptDialogOpen(false)
  }

  const handleRefundReceiptDialogOpen = () => {
    setRefundReceiptDialogOpen(true)
  }

  const handleRefundReceiptDialogClose = () => {
    setRefundReceiptDialogOpen(false)
  }

  const [refundHistoryDialogOpen, setrefundHistoryDialogOpen] = useState(false);
const [selectedPI, setSelectedPI] = useState<string | null>(null);


const openRefundHistory = (paymentIntentId: string) => {
  setSelectedPI(paymentIntentId);
  setrefundHistoryDialogOpen(true);
};

  /*FOR PAGINATION */
  const [page] = useState(0)
  const [count, setCount] = useState(0)
  const [pageSize] = useState(5)
  const [currentPage, setCurrentPage] = useState(1)
  // const [lowerLimit, setLowerLimit] = useState((currentPage - 1) * pageSize)
  // const [upperLimit, setUpperLimit] = useState(currentPage * pageSize)
  /*FOR FILTERS AND SEARCH */
  // set start date to before faber launch
  // const [startDate, setStartDate] = useState<Date>(new Date(2022, 9, 1))
  // const [endDate, setEndDate] = useState<Date>(changeMonth(new Date(), +3))
  // const [isSearchFilteredOn, setIsSearchFilteredOn] = useState(false)
  // const [isFilteredOn, setIsFilteredOn] = useState(false)
  const [filteredData, setFilteredData] = useState<
    GetCustomerPaymentTransaction[]
  >([])
  // TO DO: WHEN FILTER BY PAYMENT STATUS IS UP
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [filteredValue, setFilteredValue] = useState('')
  // const [searchOption, setSearchOption] = useState('Date Range')
  // const [textValue, setTextValue] = useState('')

  /*STATE OF DATA RETRIEVED */
  const [transactionData, setTransactionData] =
    useState<GetCustomerPaymentTransaction>()

  /* MEMOIZED HELPER FUNCTIONS */
  // const checkIsDateWithin = useCallback(
  //   (updatedDate: string) => {
  //     return isWithinInterval(new Date(updatedDate), {
  //       start: new Date(startDate),
  //       end: new Date(endDate)
  //     })
  //   },
  //   [startDate, endDate]
  // )
  /*EVENT HANDLERS */

  const {
    openModal: openRefundDialog,
    closeModal: closeRefundDialog,
    isShowing: isRefundDialogShowing
  } = useModal()

  const {
    openModal: openPartialRefundDialog,
    closeModal: closePartialRefundDialog,
    isShowing: isPartialRefundDialogShowing
  } = useModal()

  const {
    isShowing: permissionSnackbarOpen,
    openModal: handlePermissionSnackbarOpen,
    closeModal: handlePermissionSnackbarClose
  } = useModal()

  const handleRefundDialog = () => {
    if (![ALLOWED_ROLES.OPS_OWNER, ALLOWED_ROLES.OPS].includes(faberAdminRole)|| !faberRefundFlag) {
      handlePermissionSnackbarOpen()
    } else openRefundDialog()
  }

  const handlePartialRefundDialog = () => {
    if (![ALLOWED_ROLES.OPS_OWNER, ALLOWED_ROLES.OPS].includes(faberAdminRole)|| !faberRefundFlag) {
      handlePermissionSnackbarOpen()
    } else openPartialRefundDialog()
  }

  //pagination handling
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value)
  }

  // TODO: fix filters
  //filters handling
  // const handleFilterSelection = (value: string) => {
  //   setIsFilteredOn(true)
  //   setFilteredValue(value)
  // }
  // const handleClearFilterSelection = () => {
  //   setIsFilteredOn(false)
  //   setFilteredValue('')
  // }
  // //search handling
  // const handleSelectOption = (_, v) => {
  //   setSearchOption(v)
  // }

  // const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setTextValue(e.target.value.trim())
  //   if (e.target.value === '') {
  //     setIsSearchFilteredOn(false)
  //     setFilteredData(customerTxData?.data.body.data ?? [])
  //   } else {
  //     setIsSearchFilteredOn(true)
  //   }
  // }
  // const onDateChange = () => {
  //   setIsSearchFilteredOn(true)
  // }
  /*API REQUEST */

  const faberToken = OrbitSession.get('faberToken')
  const isSg = customerRow.countryCode === '+65'

  /* eslint-disable no-unused-vars */
  const {
    isLoading: isCustomerTransactionLoading,
    refetch: refetchPaymentLogs
  } = useQuery(
    [
      'getIndividualCustomerTransaction',
      customerRow.countryCode,
      customerId,
      pageSize
    ],
    async () => {
      return PaymentAPI.getCustomerTransactions({
        customerId: customerId ? customerId : '',
        offset: currentPage - 1,
        limit: pageSize,
        order: 'desc'
      })
    },
    {
      enabled: isSg,
      onSuccess: (res) => {
        setCount(Math.ceil(res.data.body.total / pageSize))
        setFilteredData(res.data.body.data)
      }
    }
  )

  const {
    data: invoices,
    isLoading: isCustomerInvoiceLoading,
    refetch: refetchCustomerInvoice
  } = useQuery(
    [
      'getCustomerInvoiceList',
      customerRow.countryCode,
      customerId,
      currentPage,
      pageSize
    ],
    async () => {
      return DataApi.getCustomerInvoiceList(
        faberToken,
        customerId ?? '',
        pageSize,
        (currentPage - 1) * pageSize
      )
    },
    {
      onSuccess: (res) => {
        if (isSg) return
        const invoicePayload = res?.data?.data
        const total =
          invoicePayload?.pagination?.total ?? invoicePayload?.total ?? 0
        setCount(total ? Math.ceil(total / pageSize) : 0)
      }
    }
  )

  const invoiceData: InvoiceTransaction[] = useMemo(() => {
    const invoicePayload = invoices?.data?.data
    const invoiceList =
      invoicePayload?.invoices ?? invoicePayload?.data ?? []

    if (!invoiceList.length) return []

    const formatted = invoiceList
      .map((invoice) => ({
        ...invoice,
        amount: invoice.amount
      }))
      .sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      )

    return formatted
  }, [invoices?.data?.data])

  const { data: customerPacks, isLoading: isCustomerPacksLoading } = useQuery(
    ['customer-allocation-packs', customerId, page, invoiceData?.length],
    async () => {
      return await EsimAPI.getCustomerPacks({ 
        userId: customerId ?? '',
        faberToken,
        limit: invoiceData.length,
        offset: page * invoiceData.length
      })
    }
  )

  useEffect(() => {
    refetchCustomerInvoice()
    if (isSg) {
      refetchPaymentLogs()
    }
  }, [currentPage, isSg, isRefundDialogShowing, isPartialRefundDialogShowing])

  const STATUS_COLORS: Record<string, string> = {
    failed: '#cc005a',
    refunded: '#CC0C00',
    pending: '#FFA500',
    completed: '#4CAF50',
    default: '#00C0CC'
  }

  return (
    <>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <ColorBox
          sx={{
            width: '100%',
            minHeight: '80vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            minWidth: '800px'
          }}
        >
          <>
            <Box sx={{ height: '90%' }}>
              {(isSg && isCustomerTransactionLoading) ||
              isCustomerPacksLoading ||
              (!isSg && isCustomerInvoiceLoading) ? (
                <CircularProgress />
              ) : (
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <ColorBox
                    sx={{
                      width: '100%',
                      minHeight: '80vh',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'stretch',
                      minWidth: '800px'
                    }}
                  >
                    <Box sx={{ height: '90%' }}>
                      {isSg ? (
                        filteredData.map((tx, index) => (
                          <React.Fragment key={tx.trn + index}>
                            <Card
                              sx={{
                                mb: 3,
                                border: '1px solid #ECEFF4',
                                boxShadow: 'none'
                              }}
                            >
                              <CardContent
                                sx={{
                                  display: 'flex',
                                  pb: 0,
                                  p: 2
                                }}
                              >
                                <Box
                                  pr={2}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}
                                >
                                  <Avatar
                                    sx={{
                                      p: 2,
                                      bgcolor: `${
                                        tx.paymentStatus === 'FAILED'
                                          ? '#cc005a'
                                          : tx.paymentStatus === 'REFUNDED'
                                          ? '#CC0C00'
                                          : '#00C0CC'
                                      }`,
                                      fontSize: '0.8em',
                                      textAlign: 'center',
                                      mb: 1
                                    }}
                                  >
                                    {tx.paymentStatus.toUpperCase()}
                                  </Avatar>
                                </Box>

                                <Grid container>
                                  <Grid item xs={2}>
                                    <Stack>
                                      <StyledHeaderText>
                                        Payment Reference ID
                                      </StyledHeaderText>
                                      {tx.paidFor == null ? (
                                        <StyledBodyText>
                                          {tx.trn}
                                        </StyledBodyText>
                                      ) : customerId === tx.paidFor ? (
                                        <StyledBodyText>
                                          <b>Paid by</b> {tx.userId}
                                        </StyledBodyText>
                                      ) : (
                                        <StyledBodyText>
                                          {tx.trn}
                                          <br />
                                          <b>Paid for</b> {tx.paidFor}
                                        </StyledBodyText>
                                      )}
                                    </Stack>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <Stack>
                                      <StyledHeaderText>
                                        Amount
                                      </StyledHeaderText>
                                      <StyledBodyText>
                                        {`${
                                          tx.currency || ''
                                        } ${tx.amount.toString()}`}
                                      </StyledBodyText>
                                    </Stack>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <Stack>
                                      <StyledHeaderText>
                                        Payment Type
                                      </StyledHeaderText>
                                      <StyledBodyText>
                                        {tx.paymentType ===
                                        'STRIPE_CHECKOUT_SESSION'
                                          ? 'FAST TRACK / LOUNGE ACCESS'
                                          : tx.paymentType}
                                      </StyledBodyText>
                                    </Stack>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <Stack>
                                      <StyledHeaderText>
                                        Promo Code
                                      </StyledHeaderText>
                                      <StyledBodyText>
                                        {tx.promocode ??
                                          'Did not use a promocode'}
                                      </StyledBodyText>
                                    </Stack>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <Stack>
                                      <StyledHeaderText>
                                        Created at, Updated at
                                      </StyledHeaderText>
                                      <StyledBodyText>
                                        {format(
                                          new Date(tx.created),
                                          'dd MMM yyyy HH:mm'
                                        )}
                                      </StyledBodyText>
                                      <StyledBodyText>
                                        {format(
                                          new Date(tx.updated),
                                          'dd MMM yyyy HH:mm'
                                        )}
                                      </StyledBodyText>
                                    </Stack>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <Stack>
                                      <StyledHeaderText>
                                        More actions
                                      </StyledHeaderText>
                                      <Box>
                                        <TransactionActionMenu
                                          tx={tx}
                                          customerRow={customerRow}
                                          setTransactionData={
                                            setTransactionData
                                          }
                                          handleRefundDialog={
                                            handleRefundDialog
                                          }
                                          handleReceiptDialogOpen={
                                            handleReceiptDialogOpen
                                          }
                                          handlePartialRefundDialog={
                                            handlePartialRefundDialog
                                          }
                                          handleRefundReceiptDialogOpen={
                                            handleRefundReceiptDialogOpen
                                          }
                                        />
                                      </Box>
                                    </Stack>
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </React.Fragment>
                        ))
                      ) : invoiceData.length === 0 ? (
                        <TextColorFontBody>
                          No Transactions Found
                        </TextColorFontBody>
                      ) : (
                        invoiceData.map((invoice, index) => (
                          <React.Fragment key={invoice.invoice_id + index}>
                            <Card
                              sx={{
                                mb: 3,
                                border: '1px solid #ECEFF4',
                                boxShadow: 'none'
                              }}
                            >
                              <CardContent
                                sx={{
                                  display: 'flex',
                                  pb: 0,
                                  p: 2,
                                  flexDirection: 'row'
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    pb: 2
                                  }}
                                >
                                  <Avatar
                                    sx={{
                                      p: 2,
                                      bgcolor:
                                        STATUS_COLORS[invoice.status] ||
                                        STATUS_COLORS.default,
                                      fontSize: '0.4em',
                                      fontWeight: 500,
                                      textAlign: 'center',
                                      mb: 1
                                    }}
                                  >
                                    {invoice.status.toUpperCase()}
                                  </Avatar>{' '}
                                </Box>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexWrap: 'wrap'
                                  }}
                                >
                                  <Box sx={{ flex: 1, minWidth: 160, p: 1 }}>
                                    <StyledHeaderText>
                                      Catalog Name
                                    </StyledHeaderText>
                                    <StyledBodyText>
                                      {invoice.catalog_name}
                                    </StyledBodyText>
                                  </Box>
                                  <Box sx={{ flex: 1, minWidth: 200, p: 1 }}>
                                    <StyledHeaderText>
                                      Payment Reference ID
                                    </StyledHeaderText>
                                    <StyledBodyText>
                                      {invoice.payment_intent}
                                    </StyledBodyText>
                                  </Box>
                                  <Box sx={{ flex: 1, minWidth: 80, p: 1 }}>
                                    <StyledHeaderText>
                                      Total Amount
                                    </StyledHeaderText>
                                    <StyledBodyText>{`${invoice.currency} ${invoice.amount}`}</StyledBodyText>
                                  </Box>
                                  <Box sx={{ flex: 1, minWidth: 180, p: 1 }}>
                                    <StyledHeaderText>
                                      Payment Type
                                    </StyledHeaderText>
                                    <StyledBodyText>
                                      {invoice.payment_type}
                                    </StyledBodyText>
                                  </Box>
                                  <Box sx={{ flex: 1, minWidth: 120, p: 1 }}>
                                    <StyledHeaderText>
                                      Quantity
                                    </StyledHeaderText>
                                    <StyledBodyText>
                                      {invoice.quantity}
                                    </StyledBodyText>
                                  </Box>
                                  <Box sx={{ flex: 1, minWidth: 120, p: 1 }}>
                                    <StyledHeaderText>
                                      Promo Code
                                    </StyledHeaderText>
                                    <StyledBodyText>
                                      {invoice.promocode === ''
                                        ? 'N/A'
                                        : invoice.promocode}
                                    </StyledBodyText>
                                  </Box>
                                  <Box sx={{ flex: 1, minWidth: 160, p: 1 }}>
                                    <StyledHeaderText>
                                      Created/Updated At
                                    </StyledHeaderText>
                                    <StyledBodyText>
                                      {format(
                                        new Date(invoice.created_at),
                                        'dd MMM yyyy HH:mm'
                                      )}
                                    </StyledBodyText>
                                    <StyledBodyText>
                                      {format(
                                        new Date(invoice.updated_at),
                                        'dd MMM yyyy HH:mm'
                                      )}
                                    </StyledBodyText>
                                  </Box>
                       
                                  <Button
                                    size='small'
                                    onClick={() => openRefundHistory(invoice.payment_intent)}
                                  >
                                    Refund history
                                  </Button>
                                  <Box sx={{ flex: 1, minWidth: 120, p: 1 }}>
                                    <StyledHeaderText>
                                      More actions
                                    </StyledHeaderText>
                                    <Box>
                                      <TransactionActionMenu
                                        tx={{
                                          allocationId:
                                            customerPacks?.data?.body?.data?.find(
                                              (pack) =>
                                                pack.invoice_id ===
                                                invoice.invoice_id
                                            )?.id,
                                          trn: invoice.invoice_id,
                                          payment_intent:
                                            invoice.payment_intent,
                                          userId: customerRow.userID,
                                          paymentStatus: invoice.status,
                                          amount: Number(invoice.amount),
                                          currency: invoice.currency,
                                          paymentType: invoice.payment_type,
                                          promocode: invoice.promocode,
                                          created: invoice.created_at,
                                          updated: invoice.updated_at,
                                          catalogName: invoice.catalog_name
                                        }}
                                        customerRow={customerRow}
                                        setTransactionData={setTransactionData}
                                        handleRefundDialog={handleRefundDialog}
                                        handleReceiptDialogOpen={
                                          handleReceiptDialogOpen
                                        }
                                        handlePartialRefundDialog={
                                          handlePartialRefundDialog
                                        }
                                        handleRefundReceiptDialogOpen={
                                          handleRefundReceiptDialogOpen
                                        }
                                      />
                                    </Box>
                                  </Box>
                                </Box>
                              </CardContent>
                            </Card>
                          </React.Fragment>
                        ))
                      )}
                    </Box>
                  </ColorBox>
                </Box>
              )}{' '}
            </Box>
            <Box sx={{ mt: 5 }}>
              <Pagination
                hidePrevButton
                count={count}
                color='primary'
                page={currentPage}
                onChange={handlePageChange}
                sx={{
                  mt: 4.5,
                  '& .MuiPagination-ul': { flexWrap: 'wrap', rowGap: 1 },
                  '& .MuiPaginationItem-root': {
                    margin: '0 6px',
                    minWidth: 36,
                    height: 36,
                    boxSizing: 'border-box'
                  },
                  '& .MuiPaginationItem-root.Mui-selected': {
                    zIndex: 1
                  }
                }}
              />
            </Box>
          </>
        </ColorBox>
        <NoPermissionSnackbar
          handlePermissionSnackbarClose={handlePermissionSnackbarClose}
          permissionSnackbarOpen={permissionSnackbarOpen}
        />

        <RefundFormV2Dialog
          handleDialogClose={closeRefundDialog}
          dialogOpen={isRefundDialogShowing}
          paymentId={
            transactionData?.payment_intent
              ? transactionData.payment_intent
              : ''
          }
          refetchPaymentLogs={refetchPaymentLogs}
          iccid={customerRow.iccid ? customerRow.iccid : ''}
          userId={customerRow.userID}
          email={customerRow.userEmail ? customerRow.userEmail : ''}
          transactionType={
            transactionData?.paymentType ? transactionData.paymentType : ''
          }
          handleRefundRequestTabChange={handleRefundRequestTabChange}
        />

        <RefundFormV3Dialog
          handleDialogClose={closePartialRefundDialog}
          dialogOpen={isPartialRefundDialogShowing}
          catalogName={transactionData?.catalogName || ''}
          paymentId={transactionData?.trn || ''}
          allocationId={transactionData?.allocationId}
          paymentIntent={
            transactionData?.payment_intent
              ? transactionData.payment_intent
              : ''
          }
          iccid={customerRow.iccid || ''}
          userId={customerRow.userID}
          email={customerRow.userEmail || ''}
          refetchPaymentLogs={refetchPaymentLogs}
          handleRefundRequestTabChange={handleRefundRequestTabChange}
          transactionType={transactionData?.paymentType || ''}
          amount={transactionData?.amount || 0}
          currency={transactionData?.currency}
        />

        <ResendReceiptDialog
          receiptDialogOpen={receiptDialogOpen}
          handleDialogClose={handleReceiptDialogClose}
          transanctionNo={transactionData?.trn ? transactionData.trn : ''}
          email={customerRow.userEmail ? customerRow.userEmail : ''}
          userId={customerRow.userID}
          transactionType={
            transactionData?.paymentType ? transactionData.paymentType : ''
          }
          isExternal={false}
          paymentIntent={
            transactionData?.payment_intent
              ? transactionData?.payment_intent
              : ''
          }
        />

        <RefundReceiptDialog
          refundReceiptDialogOpen={refundReceiptDialogOpen}
          handleRefundReceiptDialogClose={handleRefundReceiptDialogClose}
          transanctionNo={transactionData?.trn ? transactionData.trn : ''}
          email={customerRow.userEmail ? customerRow.userEmail : ''}
        />

        <RefundHistoryDialog
          faberToken={faberToken}
          dialogOpen={refundHistoryDialogOpen}
          paymentIntentId={selectedPI}
          customerId={customerId}
          handleDialogClose={() => setrefundHistoryDialogOpen(false)}
        />
      </Box>
    </>
  )
}

export default PaymentLogsV2

interface PaymentLogsProps {
  customerId: string | undefined
  customerRow: TransformedFaberUserData
  handleRefundRequestTabChange: () => void
}